/**
 * Pfade des Blogs.
 *
 * Eigene Datei, damit alles, was nur eine URL braucht (Schema-Objekte, Layout,
 * Navigation), nicht den Inhalts-Glob aus `posts.ts` mitzieht.
 *
 * Bewusst ohne Markt-Präfix: der Blog erscheint vorerst nur auf Deutsch. Kommt
 * eine englische Fassung, wird daraus ein Eintrag in `PUBLIC_MARKET_ROUTES` —
 * dann greifen hreflang, Markt-Umschalter und Prerender automatisch.
 */
export const BLOG_INDEX_PATH = "/blog";

export function blogArticlePath(slug: string): string {
  return `${BLOG_INDEX_PATH}/${String(slug ?? "").trim()}`;
}

/** Gehört ein Pfad zum Blog? Wird für Navigation und Prüf-Skripte gebraucht. */
export function isBlogPath(pathname: string): boolean {
  const value = String(pathname ?? "");
  return value === BLOG_INDEX_PATH || value.startsWith(`${BLOG_INDEX_PATH}/`);
}
